import { Container, Col, Row, Card } from "react-bootstrap";
import { SpinnerBlock } from "../../../Utils/CustomComponent";
import imb_portfolio_balance from "../../../assets/images/upcoming-payments.png";
import { Calendar2Check, Coin } from "react-bootstrap-icons";

function GBPComponent({ kpi }) {
  return (
    <Container fluid className="p-0 h-100">
      <Card className="border border-primary shadow-sm rounded-lg h-100">
        <Card.Body
          className="h-100"
          style={{ display: "flex", alignItems: "center" }}
        >
          <Row className="g-3 w-100">
            {kpi?.[0] ? (
              Object.keys(kpi[0]).map((key, index) => (
                <Col xs={12} sm={6} lg={3} key={index} className="h-100">
                  <div className="border rounded p-5 shadow-sm bg-light text-center h-100">
                    {key === "Next Payment" ? (
                      <Calendar2Check fill="var(--primary-color)" size={40} />
                    ) : (
                      <Coin fill="var(--primary-color)" size={40} />
                    )}
                    <div className="pt-5">
                      <h6 className="mb-1 text-muted text-capitalize">{key}</h6>
                      <span className="fw-bold text-primary">
                        {kpi[0][key]}
                      </span>
                    </div>
                  </div>
                </Col>
              ))
            ) : (
              <SpinnerBlock height="30vh" />
            )}
          </Row>
        </Card.Body>
      </Card>
    </Container>
  );
}

export default GBPComponent;
